<footer
  class="bg-gray-950 text-white bottom-0 min-w-full ios-fixed-position-fix"
>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      <!-- Company Info -->
      <div class="space-y-4">
        <figure>
          <img
            src="assets/logo/logo_full_white.png"
            alt="Logo"
            class="h-20 w-auto"
          />
        </figure>
        <p class="text-sm">Delivery rápido y seguro</p>
      </div>

      <!-- Quick Links -->
      <!-- <div class="space-y-4">
        <h3 class="text-lg font-semibold text-amber-400">Enlaces Rápidos</h3>
        <ul class="space-y-2">
          <li><a href="#" class="hover:text-amber-400 text-sm">Inicio</a></li>
          <li>
            <a href="#" class="hover:text-amber-400 text-sm">Productos</a>
          </li>
          <li>
            <a href="#" class="hover:text-amber-400 text-sm">Categorías</a>
          </li>
          <li><a href="#" class="hover:text-amber-400 text-sm">Ofertas</a></li>
        </ul>
      </div> -->

      <!-- Support -->
      <!-- <div class="space-y-4">
        <h3 class="text-lg font-semibold text-amber-400">Soporte</h3>
        <ul class="space-y-2">
          <li>
            <a href="#" class="hover:text-amber-400 text-sm">Centro de Ayuda</a>
          </li>
          <li><a href="#" class="hover:text-amber-400 text-sm">Contacto</a></li>
          <li>
            <a href="#" class="hover:text-amber-400 text-sm"
              >Política de Privacidad</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-amber-400 text-sm"
              >Términos y Condiciones</a
            >
          </li>
        </ul>
      </div> -->

      <!-- Social Media -->
      <div class="space-y-4">
        <h3 class="text-lg font-semibold text-amber-400">Síguenos</h3>
        <div class="social-links flex flex-row flex-nowrap space-x-6 md:space-x-8">
          <a target="_blank" href="https://www.facebook.com/subitomex" class="text-white hover:text-amber-400 transition-colors duration-300">
            <i class="fab fa-facebook-f text-xl"></i>
          </a>
          <a target="_blank" href="https://api.whatsapp.com/send/?phone=522211189655&text&type=phone_number&app_absent=0" class="text-white hover:text-amber-400 transition-colors duration-300">
            <i class="fab fa-whatsapp text-xl"></i>
          </a>
          <a target="_blank" href="https://www.instagram.com/subito_mx_/" class="text-white hover:text-amber-400 transition-colors duration-300">
            <i class="fab fa-instagram text-xl"></i>
          </a>
          <a target="_blank" href="https://www.tiktok.com/@subitomx" class="text-white hover:text-amber-400 transition-colors duration-300">
            <i class="fab fa-tiktok text-xl"></i>
          </a>
          <a target="_blank" href="https://www.youtube.com/channel/UCYmvmilJmoekmOLlFLjQ4cQ/about" class="text-white hover:text-amber-400 transition-colors duration-300">
            <i class="fab fa-youtube text-xl"></i>
          </a>
        </div>
      </div>


    </div>

    <!-- Copyright -->
    <div class="border-t border-gray-200 mt-12 pt-8">
      <p class="text-center text-gray-500 text-sm">
        © {{ currentYear }} Súbito. Todos los derechos reservados. Hecho con ❤️ en México.
      </p>
    </div>
  </div>
</footer>
